import {
  CheckCircle,
  Pending,
  HourglassEmpty,
  Replay,
  Cancel,
  Block,
} from "@mui/icons-material";

export const muiColorHex = {
  success: "#2e7d32", // green
  info: "#0288d1", // blue
  warning: "#ed6c02", // orange
  error: "#d32f2f", // red
  secondary: "#9c27b0", // purple
};

export const paymentStatusConfig = {
  succeeded: {
    label: "Succeeded",
    color: "success",
    icon: <CheckCircle sx={{ fontSize: 20, color: muiColorHex["success"] }} />,
  },
  approved: {
    label: "Approved",
    color: "success",
    icon: <CheckCircle sx={{ fontSize: 20 }} color="info" />,
  },
  pending: {
    label: "Pending",
    color: "info",
    icon: <Pending sx={{ fontSize: 20 }} color="info" />,
  },
  hold: {
    label: "On Hold",
    color: "info",
    icon: <HourglassEmpty sx={{ fontSize: 20 }} color="info" />,
  },
  pending_review: {
    label: "Pending For Review",
    color: "warning",
    icon: <HourglassEmpty sx={{ fontSize: 20 }} />,
  },
  returned: {
    label: "Returned",
    color: "warning",
    icon: <Replay sx={{ fontSize: 20 }} />,
  },
  release_hold: {
    label: "Release Hold",
    color: "secondary",
    icon: <Replay sx={{ fontSize: 20 }} />,
  },
  failed: {
    label: "Failed",
    color: "error",
    icon: <Cancel sx={{ fontSize: 20 }} />,
  },
  terminally_failed: {
    label: "Terminally Failed",
    color: "error",
    icon: <Cancel sx={{ fontSize: 20 }} />,
  },
  expired: {
    label: "Expired",
    color: "error",
    icon: <Block sx={{ fontSize: 20 }} />,
  },
  rejected: {
    label: "Rejected",
    color: "error",
    icon: <Cancel sx={{ fontSize: 20 }} />,
  },
};

// Prize configuration matching your theme
export const wheelPrizes = [
  {
    option: "$1",
    value: 1,
    style: { backgroundColor: "#ff9c19", textColor: "#1a1a1a" }, // bright gold → dark text = good
  },
  {
    option: "$2",
    value: 2,
    style: { backgroundColor: "#ffd600", textColor: "#1a1a1a" }, // yellow → dark text = best contrast
  },
  {
    option: "$5",
    value: 5,
    style: { backgroundColor: "#e2008a", textColor: "#ffffff" }, // magenta → white = strong contrast
  },
  {
    option: "$10",
    value: 10,
    style: { backgroundColor: "#ff4d6d", textColor: "#ffffff" }, // coral → white = clean and legible
  },
  {
    option: "$30",
    value: 30,
    style: { backgroundColor: "#f50057", textColor: "#ffffff" }, // hot pink → white pops better
  },
  {
    option: "$50",
    value: 50,
    style: { backgroundColor: "#9c27b0", textColor: "#ffffff" }, // royal purple → white = best contrast
  },
  {
    option: "$65",
    value: 65,
    style: { backgroundColor: "#ff6f00", textColor: "#1a1a1a" }, // amber → dark text = readable
  },
  {
    option: "$75",
    value: 75,
    style: { backgroundColor: "#c51162", textColor: "#ffffff" }, // deep rose → white = ideal
  },
];

export const fabMarginByScreen = {
  dashboard: 100,
  history: 100,
  wallet: 100,
  cashout: 100,
  profile: 100,
  "spin-a-wheel": 100,
};
